export type FontRequestType = {
   locale: string
   account?: string
   id?: string | number
}

export type FontResponseType = {
   families: Array<string>
   googleFontUrl: string
}

export async function getFonts(request: FontRequestType): Promise<FontResponseType | null> {
   const { locale, account } = request
   try {
      const result = await fetch(`${process.env.REACT_APP_PUBLIC_CORE_API}/v2/${account}/58728b69-0cd2-42a6-8d00-6d00841b9763/fonts/available?locale=${locale}`,
         {
            method: 'GET',
         },
      )
      if (result.status !== 200) {
         throw new Error(`error ${result.status}`)
      }
      return result.json()
   } catch (error) {
      return null
   }
}